import React from 'react';
import { Spinner } from '../Spinner/Spinner';
import './LoadingPage.css';
import { Container } from '../Container/Container';

interface Props {
  title?: string;
}

export function LoadingPage({ title }: Props): JSX.Element {
  return (
    <Container className="loading-page">
      {title && <div className="loading-page__title">{title}</div>}
      <Spinner scale="1.5" color="#ea3c23" />
    </Container>
  );
}
